import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button", "status"]

  async copy(event) {
    const text = this.sourceTarget.value || this.sourceTarget.innerText || this.sourceTarget.textContent
    const button = event?.currentTarget
    const dropdown = button?.closest("details")

    await this.writeText(text)

    dropdown?.removeAttribute("open")
    this.showCopied(button)
    this.dispatch("copied")
  }

  async writeText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text)
        return
      } catch {
        // Fall back to the temporary textarea path below.
      }
    }

    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.setAttribute("readonly", "")
    textarea.style.position = "fixed"
    textarea.style.left = "-9999px"
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand("copy")
    textarea.remove()
  }

  showCopied(button = this.hasButtonTarget ? this.buttonTarget : null) {
    if (this.hasStatusTarget) {
      clearTimeout(this.statusTimeout)
      this.statusTarget.classList.remove("hidden")
      this.statusTarget.textContent = "Copied to clipboard"

      this.statusTimeout = window.setTimeout(() => {
        this.statusTarget.classList.add("hidden")
      }, 1800)

      return
    }

    if (!button) return

    const original = button.textContent
    button.textContent = "Copied"

    window.setTimeout(() => {
      button.textContent = original
    }, 1400)
  }
}
